module.exports = {
  context: {
    title: 'Language',
    nodes: [
      {
        children: [
          {
            title: 'English',
            url: '/'
          },
          {
            title: 'Spanish',
            url: '/es'
          }
        ]
      }
    ]
  }
}
